import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Modal } from "antd";
import { observer } from "mobx-react";
import { useState } from "react";
import { formServiceAttributesFromTemplate } from "@devowl-wp/react-cookie-banner-admin";
import { useStores } from "../../../store/stores.js";
import { __ } from "../../../utils/i18n.js";
import { CookieEditForm } from "../cookies/form.js";
const BlockerFormNoticeNoneExistingCookies = observer(({ nonExistingServices, onCreated })=>{
    const [openId, setOpenId] = useState();
    const groups = useStores().cookieStore.groups.sortedGroups.map(({ data: { id, name } })=>({
            id,
            name
        }));
    // Created templates to hide them from the list
    const [created, setCreated] = useState([]);
    const useNoneExistingCookies = (nonExistingServices || []).filter(({ identifier })=>created.indexOf(identifier) === -1);
    // Create modal windows as they should always be available in React tree (avoid "Can't perform a React state update on an unmounted component")
    const modalWindows = nonExistingServices?.map((template)=>{
        const { identifier, version } = template;
        return /*#__PURE__*/ _jsx(Modal, {
            open: openId === identifier,
            title: __("Add service"),
            width: "calc(100% - 50px)",
            bodyStyle: {
                paddingBottom: 0
            },
            footer: null,
            onCancel: ()=>setOpenId(undefined),
            children: /*#__PURE__*/ _jsx(CookieEditForm, {
                overwriteAttributes: formServiceAttributesFromTemplate(template, {
                    groups
                }),
                navigateAfterCreation: false,
                scrollToTop: false,
                template: {
                    identifier,
                    version
                },
                onCreated: (model)=>{
                    setOpenId(undefined);
                    setCreated([
                        ...created,
                        openId
                    ]);
                    onCreated(model);
                }
            })
        }, identifier);
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            modalWindows,
            useNoneExistingCookies.length === 0 ? null : /*#__PURE__*/ _jsxs("div", {
                className: "notice notice-warning below-h2 notice-alt",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        children: __("Some services from the template could not be found. Please select (or create if not already exist) the following services:", useNoneExistingCookies.join(", "))
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        style: {
                            margin: "0 0 10px"
                        },
                        children: useNoneExistingCookies.map(({ identifier, name, subHeadline })=>/*#__PURE__*/ _jsxs("li", {
                                children: [
                                    /*#__PURE__*/ _jsxs("strong", {
                                        children: [
                                            name,
                                            subHeadline ? ` (${subHeadline})` : ""
                                        ]
                                    }),
                                    "\xa0•\xa0",
                                    /*#__PURE__*/ _jsx("a", {
                                        onClick: (e)=>{
                                            setOpenId(identifier);
                                            e.preventDefault();
                                        },
                                        children: __("Create now")
                                    })
                                ]
                            }, identifier))
                    })
                ]
            })
        ]
    });
});
export { BlockerFormNoticeNoneExistingCookies };
